import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes.ts'

import EmptyImage from 'shared/images/airplane.svg'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

export const FlightListEmpty = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoHome = () => {
    navigate(RoutingPaths.tours.path())
  }

  return (
    <div className={clsx('container', s.container)}>
      <img
        src={EmptyImage}
        alt="empty"
        className={s.empty}
      />

      <div className={s.text}>
        <p className={clsx('bold-22', s.title)}>
          {t('tours_block.empty_flights_title')}
        </p>
        <p className={clsx('medium-14', s.subTitle)}>
          {t('tours_block.empty_flights_subtitle')}
        </p>
      </div>

      <Button
        variant="solidBlue"
        className="bold-16"
        onClick={handleGoHome}
      >
        {t('go_home')}
      </Button>
    </div>
  )
}
